import { Widget } from './form-widget.model';
import { TextProperty } from './properties/text-property.model';
import { PropertyBase } from './properties/property-base.model';
import { BooleanValueProperty } from './properties/boolean-property.model';

export class RadioItemProperties extends Widget {
  constructor(data: any = {}) {
    super(data);
    const properties = {
      text: new TextProperty({
        title: data.text.title,
        value: data.text.value,
      }),
      content: new TextProperty(data.content || { title: 'Description' }),
      value: new TextProperty({
        title: data.value.title,
        value: data.value.value,
      }),
    };
    this.properties = properties;
  }
}

export class RadioCompositeItemsProperties extends PropertyBase {
  constructor(data: any = {}) {
    super(data);
    this.title = data.title || 'Items';
    this.value = [];
    const valuesCheck: any = [];
    data.value.forEach((item, index) => {
      const value = new RadioItemProperties(item.properties);
      // Prevent value duplicates (inherited from old forms)
      try {
        if (valuesCheck.indexOf(value.properties.value.value) > -1) {
          value.properties.value.value = value.properties.value.value + this.numberToLetter(index);
        }
        valuesCheck.push(value.properties.value.value);
      } catch (e) {}
      this.value.push(<any>value);
    });
  }

  numberToLetter(number) {
    const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    let result = '';
    let charIndex = number % alphabet.length;
    let quotient = number / alphabet.length;
    if (charIndex - 1 === -1) {
      charIndex = alphabet.length;
      quotient--;
    }
    result = alphabet.charAt(charIndex - 1) + result;
    if (quotient >= 1) {
      return this.numberToLetter(+quotient);
    } else {
      return result;
    }
  }
}

export class FbRadioCompositeWidget extends Widget {
  constructor(data: any = {}) {
    super(data);

    this.title = 'Single Choice';
    this.name = 'fb-radio-composite';
    this.properties = this.defaultProperties(data.properties);
  }

  defaultProperties(data: any = {}) {
    const properties = {
      required: new BooleanValueProperty(data.required || { title: 'Required' }),
      text: new TextProperty({
        value: data.text ? data.text.value : 'Single Choice',
      }),
      content: new TextProperty(data.content || { title: 'Description' }),
      value: new TextProperty(data.value),
      items: new RadioCompositeItemsProperties(data.items),
      columns: new TextProperty({
        title: 'Columns',
        value: data.columns ? +data.columns.value : 1,
      }),
    };
    return properties;
  }

  isValid() {
    if (!this.isRequired()) {
      return true;
    }
    if (this.properties.value?.value && `${this.properties.value.value}`.trim()) {
      return true;
    }
    return false;
  }
}
